import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "path"
    }}>{`Path`}</h1>
    <p>{`A path.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the Path (a SplineItem, Polygon, GraphicLine, Rectangle, Oval, TextFrame, EndnoteTextFrame, MediaItem, Sound, Movie, Button, MultiStateObject, ClippingPathSettings or TextWrapPreference).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`index`}</strong>{` `}</p>
      <p parentName="blockquote">{`The index of the Path within its containing object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`PathPoints `}<strong parentName="p">{`pathPoints`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of path points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PathType `}<strong parentName="p">{`pathType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The path type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`entirePath`}</strong>{` `}</p>
      <p parentName="blockquote">{`A list of the coordinates of all of the path points on the path, including anchor points and left- and right-direction points. When creating a path using this property, supply either a list of anchor point coordinates ([`}{`[x1, y1]`}{`, `}{`[x2, y2]`}{`, ...]) or a list of anchor point, left-direction point, and right-direction point coordinates ([[`}{`[x1, y1]`}{`, `}{`[x2, y2]`}{`, `}{`[x3, y3]`}{`], [`}{`[x4, y4]`}{`, `}{`[x5, y5]`}{`, `}{`[x6, y6]`}{`], ...]). Note: Providing only anchor points results in a path on which all of the path points are connected with straight line segments; supplying the positions of left- and right-direction points specifies curved line segments. Can return: Array of Arrays of 2 Units.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`remove`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Deletes the Path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`reverse`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Reverses the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the Path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Path `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      